import React from 'react';
import styles from './HeaderOnlyPage.module.scss';

type Props = {
  title: string;
};

const HeaderOnlyPage: React.FC<Props> = ({ title }) => (
  <header className={styles.header}>
    <div className={styles.header__inner}>
      <h1 className={styles.header__title}>{title}</h1>
    </div>
  </header>
);

export default HeaderOnlyPage;
